/* eslint-disable import/max-dependencies */
import type { FC } from "react";
import React from "react";
import { Navigate } from "react-router-dom";
import environment from "environment";
import { SetupCard, withHookPropsState, withState } from "@fas/cpa-cabinet-ui";
import TabsSwitcher from "@fas/cpa-cabinet-ui/lib/TabsSwitcher";
import { withStyles } from "@mui/styles";
import {
  useTabs,
  useUserInfoForm,
  useContactInfoForm,
  usePaymentInfoForm,
} from "../../hooks";
import { setupCardStyles } from "../../styles";
import { PROFILE_PAGE } from "../../constants";
import UserInfo from "../UserInfo";
import ContactInfo from "../ContactInfo";
import PaymentInfo from "../PaymentInfo";
import tabsSwitcher from "../../styles/tabsSwitcher";

const StyledSetupCard = withStyles(setupCardStyles)(SetupCard);
const StyledTabs = withStyles(tabsSwitcher)(TabsSwitcher);
const Tabs = withHookPropsState(StyledTabs, useTabs);
const UserInfoForm = withState(UserInfo, useUserInfoForm);
const ContactInfoForm = withState(ContactInfo, useContactInfoForm);
const PaymentInfoForm = withState(PaymentInfo, usePaymentInfoForm);
export const paramsToComponents = {
  user: () => <UserInfoForm />,
  contact: () => <ContactInfoForm />,
  payment: () => <PaymentInfoForm />,
  default: () => <Navigate to={environment.links.notFound} />,
};

type Props = {
  param: keyof typeof paramsToComponents,
};

const Profile: FC<Props> = ({ param }) => (
  <StyledSetupCard title="My Account">
    <Tabs
      hookProps={{
        key: PROFILE_PAGE,
      }}
    />
    {paramsToComponents[param]()}
  </StyledSetupCard>
);

export default Profile;
